import { Class } from '@/models/class';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { GET_CLASSES, GetClassesResponse } from './gql';

export const useClasses = (filters?: object[]) => {
    const { data, loading, refetch } = useQuery<GetClassesResponse>(GET_CLASSES, {
        fetchPolicy: 'network-only',
        variables: {
            where: {
                AND: filters ?? [],
            },
            orderBy: [{ className: 'asc' }],
        },
    });
    const [classes, setClasses] = useState<Class[] | undefined>(undefined);

    useEffect(() => {
        if (data) {
            // parse data
            setClasses(() => data.classes.map((c) => new Class(c)));
        }
    }, [data]);

    return {
        classes,
        loading,
        refetch,
    };
};
